import { render, staticRenderFns } from "./FordProGatewayRedirectDialog.vue?vue&type=template&id=1c996064&"
import script from "./FordProGatewayRedirectDialog.vue?vue&type=script&lang=js&"
export * from "./FordProGatewayRedirectDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports